import { useNavigate } from "react-router-dom";

const partners = [
  {
    id: "hotel-jardin-tecina",
    name: "Hotel Jardín Tecina",
    subtitle: "LA GOMERA, WYSPY KANARYJSKIE",
    category: "Luksusowy Resort & Golf",
    description:
      "5-gwiazdkowy resort na klifach La Gomery z polem golfowym, spa i panoramicznymi widokami na Atlantyk. Ekskluzywna destynacja dla turystyki golfowej, wellness i rodzin.",
    tags: ["Golf", "Spa & Wellness", "Rodziny", "5 Gwiazdek"],
    image: "https://i.imgur.com/yQH9c3H.jpg",
    route: "/hotel-jardin-tecina",
    stats: [
      { val: "5★", label: "Kategoria" },
      { val: "18", label: "Dołków golf" },
      { val: "6", label: "Restauracji" },
    ],
  },
  {
    id: "playitas",
    name: "Playitas Resort",
    subtitle: "FUERTEVENTURA, WYSPY KANARYJSKIE",
    category: "Sport & Active Resort",
    description:
      "Wiodący resort sportowy na Fuerteventurze — idealne miejsce dla grup aktywnych, obozów treningowych, team-buildingu i eventów incentive na najwyższym poziomie.",
    tags: ["Sport", "Team Building", "Incentive", "Triathlon"],
    image: "https://api.playitas.net/sites/default/files/2023-06/Playitas_Resort_00.JPG",
    route: "/playitas",
    stats: [
      { val: "4★", label: "Kategoria" },
      { val: "50+", label: "Aktywności" },
      { val: "1000+", label: "Miejsc" },
    ],
  },
];

export default function MHPartners() {
  const navigate = useNavigate();

  return (
    <section id="partners" className="bg-gray-950 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-1 w-10 rounded-full" style={{ backgroundColor: "#CC1F1A" }} />
              <span className="text-sm font-bold uppercase tracking-widest text-gray-400">Nasi partnerzy</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white leading-tight uppercase">
              Starannie wybrane<br />
              <span style={{ color: "#FFD100" }}>destynacje</span>
            </h2>
          </div>
          <p className="text-gray-400 max-w-sm leading-relaxed">
            Każdy partner został osobiście zweryfikowany — najwyższy standard dla Twoich klientów.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="group rounded-xl overflow-hidden cursor-pointer relative"
              style={{ backgroundColor: "#111" }}
              onClick={() => navigate(partner.route)}
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full text-white" style={{ backgroundColor: "#CC1F1A" }}>
                    {partner.category}
                  </span>
                </div>
              </div>

              <div className="p-7">
                <p className="text-xs font-bold tracking-widest uppercase mb-1" style={{ color: "#CC1F1A" }}>
                  {partner.subtitle}
                </p>
                <h3 className="text-2xl font-extrabold text-white uppercase mb-3 leading-tight">
                  {partner.name}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-5">{partner.description}</p>

                <div className="flex gap-6 mb-5 pt-5 border-t border-white/10">
                  {partner.stats.map((s) => (
                    <div key={s.label}>
                      <p className="text-xl font-extrabold text-white">{s.val}</p>
                      <p className="text-xs text-gray-500 uppercase tracking-wide">{s.label}</p>
                    </div>
                  ))}
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex flex-wrap gap-2">
                    {partner.tags.map((tag) => (
                      <span key={tag} className="px-2.5 py-1 bg-white/5 text-gray-400 text-xs font-semibold rounded-md uppercase tracking-wide">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <span className="text-sm font-bold uppercase tracking-widest flex items-center gap-2 group-hover:gap-3 transition-all" style={{ color: "#CC1F1A" }}>
                    Zobacz <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
